import React from 'react';
import Layout from '../components/layout/Layout';
import HeroPage from '../components/common/HeroPage';
import Toolbar from '../components/common/Toolbar';
import SearchBar from '../components/common/SearchBar';
import Tabs from '../components/common/Tabs';
import PersonCard from '../components/common/PersonCard';

const people = [
  { name: 'Marco Ferrara', role: 'Segretario Nazionale', territory: 'Roma', avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=200&auto=format&fit=crop' },
  { name: 'Giulia Marchetti', role: 'Vicesegretaria', territory: 'Milano', avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=200&auto=format&fit=crop' },
  { name: 'Alessandro Ferretti', role: 'Resp. Organizzazione', territory: 'Torino', avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=200&auto=format&fit=crop' },
  { name: 'Sofia Ricciardi', role: 'Resp. Comunicazione', territory: 'Bologna', avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=200&auto=format&fit=crop' },
  { name: 'Davide Romano', role: 'Resp. Formazione', territory: 'Napoli', avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=200&auto=format&fit=crop' },
  { name: 'Laura Bianchi', role: 'Resp. Enti Locali', territory: 'Firenze', avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=200&auto=format&fit=crop' },
  { name: 'Matteo Galli', role: 'Resp. Lavoro', territory: 'Roma', avatar: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=200&auto=format&fit=crop' },
  { name: 'Anna Ferraro', role: 'Resp. Diritti', territory: 'Bari', avatar: 'https://images.unsplash.com/photo-1554151228-14d9def656e4?q=80&w=200&auto=format&fit=crop' },
];

const PersonePage = () => {
  const breadcrumbs = [{ label: 'Home', path: '/' }, { label: 'Persone' }];
  return (
    <Layout>
      <HeroPage breadcrumbs={breadcrumbs} overline="Organizzazione" title="Persone" subtitle="Le persone che danno vita ai Giovani Democratici: dalla segreteria nazionale ai referenti territoriali." />
      <section className="section section--sm"><div className="container">
        <Toolbar className="mb-6" left={<SearchBar placeholder="Cerca persona..." ariaLabel="Cerca persona" />} right={null} />
        <Tabs items={['Tutti', 'Segreteria', 'Segretari Regionali', 'Eletti']} className="mb-6" />
        <div className="grid grid-4">
          {people.map((p) => <PersonCard key={p.name} {...p} as="a" link="/persona-dettaglio" />)}
        </div>
      </div></section>
    </Layout>
  );
};

export default PersonePage;
